import React, {useContext, useCallback, useState} from 'react';

import ActivityButton from '~/src/components/activity/button/ActivityButton';
import ThumbsUpDown from '~/src/components/svg/action/ThumbsUpDown';
import Notification from '~/src/components/notification/Notification';
import Modal from '~/src/components/modal/Modal';

import {getContentUrl} from '~/src/utilities/helpers/link';
import {Hashes} from '~/src/utilities/constants/hash.js';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {pushRoute} from '~/src/utilities/helpers/router.js';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './RatingButton.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const RatingButton = ({metadataId, format, colorScheme, source, activityCount, onClick, isDisabled}) => {
    const {all} = useContext(SitemapContext);
    const [showNotification, setShowNotification] = useState(false);

    const handleClick = useCallback(
        (event) => {
            event.preventDefault();

            if (isDisabled) {
                return setShowNotification(true);
            }

            if (window.location.pathname.endsWith(metadataId)) {
                pushRoute(all, getContentUrl(window.location.pathname, Hashes.RATING_SECTION), true);
            } else {
                pushRoute(all, getContentUrl(metadataId.toString(), Hashes.RATING_SECTION));
            }

            trackGtm(GtmEvents.INTERACTION, {
                interactionType: 'rating',
                interactionSource: source,
                contentId: metadataId
            });

            onClick && onClick();
        },
        [isDisabled]
    );

    return (
        <React.Fragment>
            <ActivityButton
                format={format}
                colorScheme={colorScheme}
                onClick={handleClick}
                activityCount={activityCount}
                data-testid="RatingButton"
                isDisabled={isDisabled}
            >
                <ThumbsUpDown title={getTranslation('title')} />
            </ActivityButton>

            {showNotification && (
                <Modal>
                    <Notification onClose={() => setShowNotification(false)} message={getTranslation('ratingDisabledMessage')} />
                </Modal>
            )}
        </React.Fragment>
    );
};

export default RatingButton;
